module.exports = __webpack_public_path__ + "static/media/prislista.4c6021ca.jpg";